import { Episode, VoDGenre } from "@/services/apiService/api.types";

export enum VoDType {
  TvShows = "Tv Shows",
  Movies = "Movies"
}

export const enum VodPageAction {
  UpdateMoviesByGenre = "UpdateMoviesByGenre",
  UpdateTvShowsByGenre = "UpdateTvShowsByGenre",
  UpdateClosePlayer = "UpdateClosePlayer"
}

export const enum VodPageMutation {
  setViewedVodIndex = "setViewedVodIndex",
  setViewedVodType = "setViewedVodType",
  setMoviesByGenre = "setMoviesByGenre",
  setTvShowsByGenre = "setTvShowsByGenre",
  setInfoModalVodId = "setInfoModalVodId",
  setShowVodInfoModal = "setShowVodInfoModal",
  setRefocusCardId = "setRefocusCardId",
  setClosePlayer = "setClosePlayer",
  setCardControls = "setCardControls",
  setPlayedEpisodePos = "setPlayedEpisodePos",
  setShowEpisodeInfoModal = "setShowEpisodeInfoModal",
  SetActiveEpisode = "SetActiveEpisode"
}

export const enum VodPageGetter {
  GetViewedVodIndex = "GetViewedVodIndex",
  GetViewedVodType = "GetViewedVodType",
  GetMoviesByGenre = "GetMoviesByGenre",
  GetTvShowsByGenre = "GetTvShowsByGenre",
  GetInfoModalVodId = "GetInfoModalVodId",
  GetShowVodInfoModal = "GetShowVodInfoModal",
  GetRefocusCardId = "GetRefocusCardId",
  GetClosePlayer = "GetClosePlayer",
  GetCardControls = "GetCardControls",
  GetPlayedEpisodePos = "GetPlayedEpisodePos",
  GetShowEpisodeInfoModal = "GetShowEpisodeInfoModal",
  GetActiveEpisode = "GetActiveEpisode"
}
export interface VodPageState {
  viewedVodIndex?: number;
  viewedVodType?: VoDType;
  moviesByGenre: VoDGenre[];
  tvShowsByGenre: VoDGenre[];
  infoModalVodId: number;
  showVodInfoModal: boolean;
  refocusCardId: string;
  closePlayer: boolean;
  cardControls: boolean;
  playedEpisodePos?: {
    slideIndex: number;
    sliderIndex: number;
  };
  showEpisodeInfoModal: boolean;
  activeEpisode: Episode | null;
}
